import { render, staticRenderFns } from "./BuscadorFichaFila.vue?vue&type=template&id=38423ff0&"
import script from "./BuscadorFichaFila.vue?vue&type=script&lang=js&"
export * from "./BuscadorFichaFila.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports